<script setup>
import { computed, inject, nextTick, ref, watch } from 'vue';

const props = defineProps({ element: { type: Object, required: true } });
defineOptions({ inheritAttrs: false });
// HTML livre num iframe sem scripts (o canvas nunca executa o HTML colado).

const ed = inject('emailEditor');
const frame = ref(null);
const height = ref(60);
const srcdoc = computed(
  () =>
    `<!doctype html><html><body style="margin:0;font-family:Arial,sans-serif">${props.element.html || ''}</body></html>`
);
const fit = () => {
  const body = frame.value?.contentDocument?.body;
  if (body) height.value = Math.max(30, body.scrollHeight);
};
watch(
  () => ed.device.value,
  () => nextTick(fit)
);
</script>

<template>
  <iframe
    ref="frame"
    sandbox="allow-same-origin"
    class="pointer-events-none block w-full border-0"
    :style="{ height: `${height}px` }"
    :srcdoc="srcdoc"
    @load="fit"
  />
</template>
